import React, { Suspense, useState, useEffect } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import HomePage from './components/HomePage';
import DesktopRenderer from './components/DesktopRenderer';
import MobileRenderer from './components/MobileRenderer';
import './App.css';

const App = () => {
    const [isMobile, setIsMobile] = useState(false);

    // Wykrywanie urządzenia mobilnego przy ładowaniu
    useEffect(() => {
        const checkDevice = () => {
            // Sprawdzenie, czy urządzenie jest mobilne
            const userAgent = navigator.userAgent || navigator.vendor || window.opera;

            // Dwa typowe sposoby wykrywania urządzeń mobilnych
            const mobileRegex = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i;
            const isMobileDevice = mobileRegex.test(userAgent) ||
                (window.innerWidth <= 800 && window.innerHeight <= 1000);

            setIsMobile(isMobileDevice);
            console.log(`Wykryto urządzenie typu: ${isMobileDevice ? 'Mobile' : 'Desktop'}`);
        };

        // Sprawdź przy ładowaniu
        checkDevice();

        // Sprawdź również przy zmianie rozmiaru okna
        window.addEventListener('resize', checkDevice);
        return () => {
            window.removeEventListener('resize', checkDevice);
        };
    }, []);

    return (
        <div className="App">
            <Suspense fallback={<div>Loading...</div>}>
                <Routes>
                    <Route path="/" element={<HomePage />} />
                    <Route path="/explore" element={isMobile ? <MobileRenderer /> : <DesktopRenderer />} />
                    <Route path="*" element={<Navigate to="/" />} />
                </Routes>
            </Suspense>
        </div>
    );
};

export default App;
